import React from "react";
import InputField from "../../forms/input-field";
import { useFormikContext } from "formik";

const StorePaymentHistoryTab = ({ disabled = false }) => {
  const { values } = useFormikContext();

  return (
    <div className="w-full 2xl:w-[35%] lg:w-[60%] px-5 xl:px-10 mt-5">
      <InputField
        isDisabled={true}
        type="text"
        name="payment_method"
        placeholder="—"
        label="Payment Method"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="transaction_id"
        placeholder="—"
        label="Transaction ID"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="datetime-local"
        name="payment_recevie_time"
        placeholder="—"
        label="Payment Receive Time"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payer_name_as_per_bank"
        placeholder="—"
        label="Payer Name (Bank)"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payee_bank_name"
        placeholder="—"
        label="Payee Bank Name"
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payee_bank_account_no"
        placeholder="—"
        label="Payee Account No."
        labelWidth="13rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="isfc_code"
        placeholder="—"
        label="IFSC Code"
        labelWidth="13rem"
      />
      <div className="flex items-center mb-2">
        <span
          style={{ minWidth: "13rem" }}
          className="whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]"
        >
          Payment Terms Approved
        </span>
        <span className="text-[var(--head-input-fg-color)] text-[length:var(--head-input-font-size)] font-[var(--head-input-font-weight)]">
          {values.is_payment_terms_approve ? "Yes" : "No"}
        </span>
      </div>
    </div>
  );
};

export default StorePaymentHistoryTab;